import { IconFieldDesignTokens } from "@primeuix/themes/types/iconfield";

export const iconfield: IconFieldDesignTokens = {
    css: () => {
        return `
        .p-iconfield {
            .p-inputicon {
                width: auto;
            }
        }
        `;
    },
};
